import { useState, useEffect } from 'react';
import IMSDataTable from './IMSDataTable';
import { fetchIMSLogs, fetchSourceOptions } from './IMSLogviewer_api';
import Styles from './IMSLogviewer.module.scss';
import { paginateData } from './_utils';
import MaterialIcon from '@material/react-material-icon';
import classNames from 'classnames';
import ErrorCodeTable from './ErrorCodeTable';
import Modal from '@mui/material/Modal';
import { Link, useLocation } from 'react-router-dom';
import FilterControls from './IMSLogViewerControls';

export const IMSLogviewer = () => {
	const [logs, setLogs] = useState([]);
	const [paginatedLogs, setPaginatedLogs] = useState([]);
	const [displayLogs, setDisplayLogs] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const [sourceOptions, setSourceOptions] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [modalOpen, setModalOpen] = useState(false);

	const itemsPerPage = 20;
	const dataTableHeaders = [
		{ dataKey: 'LogEntryID', displayHeader: 'Log ID' },
		{ dataKey: 'Type', displayHeader: 'Type' },
		{ dataKey: 'Source', displayHeader: 'Source' },
		{ dataKey: 'CreateDate', displayHeader: 'Date' },
		{ dataKey: 'Details', displayHeader: 'Details', value: 'Details' },
	];

	useEffect(() => {
		//fetch initial dataset
		setIsLoading(true);
		fetchSourceOptions()
			.then(options => {
				let optionObjArr = options.data.map(option => {
					return { label: option.substring(0, 100), value: option };
				});
				setSourceOptions(optionObjArr);
			})
			.then(x => {
				fetchIMSLogs('F_Create_Date~1')
					.then(response => {
						setLogs(response.data);
						setError(response.error);
					})
					.then(data => {
						setIsLoading(false);
					});
			})
			.then(result => {
				setPaginatedLogs(paginateData(logs, itemsPerPage));
			})
			.then(result => {
				setDisplayLogs(paginatedLogs[currentPage - 1]);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setPaginatedLogs(paginateData(logs, itemsPerPage));
	}, [logs]);

	useEffect(() => {
		let pageLogs = paginatedLogs[currentPage - 1];
		if (pageLogs) {
			setDisplayLogs(paginatedLogs[currentPage - 1]);
		} else {
			setDisplayLogs([]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [paginatedLogs]);

	useEffect(() => {
		setDisplayLogs(paginatedLogs[currentPage - 1]);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage]);

	//update data on search
	const handleSearch = filterArgs => {
		setIsLoading(true);

		fetchIMSLogs(filterArgs)
			.then(response => {
				setLogs(response.data);
				setError(response.error);
				setPaginatedLogs(paginateData(response.data, itemsPerPage));
				setIsLoading(false);
			})
			.then(result => setCurrentPage(1));
	};

	const onPageUp = event => {
		let nextPage = currentPage + 1;
		if (paginatedLogs[nextPage - 1]) {
			setCurrentPage(currentPage + 1);
		}
	};

	const onPageDown = event => {
		let nextPage = currentPage - 1;
		if (nextPage > 0) {
			setCurrentPage(currentPage - 1);
		}
	};

	const handleModalToggle = event => {
		setModalOpen(!modalOpen);
	};

	const CustomTD = props => {
		return (
			<>
				<td key={props.key} className={Styles.cell}>
					<Link to={`${useLocation().pathname}/${props.element.ID}`}>
						Details
					</Link>
				</td>
			</>
		);
	};
	const customTdProps = {
		columnIndex: 4,
		customTDElementAtIndex: <CustomTD />,
	};

	return (
		<>
			<div className={Styles.CenterContent}>
				<div className={Styles.container_main}>
					<div className={Styles.tooltipBanner}>
						<span className={Styles.floatLeft}>Log Viewer</span>
						<span
							className={classNames(
								Styles.floatRight,
								Styles.clickable
							)}
							onClick={handleModalToggle}
						>
							<MaterialIcon icon='help' />
						</span>
					</div>

					<div className={Styles.table_container}>
						<FilterControls
							sourceOptions={sourceOptions}
							handleSearch={handleSearch}
						/>
						{displayLogs ? (
							<IMSDataTable
								data={displayLogs}
								isLoading={isLoading}
								headers={dataTableHeaders}
								// activeFilter={activeFilter}
								// onSearch={() => {
								// 	handleSearch();
								// }}
								error={error}
								paginated={true}
								pageUp={onPageUp}
								pageDown={onPageDown}
								currentPage={currentPage}
								totalPages={paginatedLogs.length}
								customTdProps={customTdProps}
							/>
						) : null}
					</div>
				</div>
			</div>
			<Modal open={modalOpen}>
				<div className={Styles.modal_container}>
					<div className={Styles.modal_body}>
						<div
							className={Styles.modal_Close}
							onClick={handleModalToggle}
						>
							<MaterialIcon icon='close' />
						</div>
						<h5 className={Styles.tooltipBanner}>
							Server Error Codes
						</h5>
						<ErrorCodeTable />
					</div>
				</div>
			</Modal>
		</>
	);
};

export default IMSLogviewer;
